export default __webpack_public_path__ + "static/media/mythsfacts.c182756f.jpg";